export const SUBSCRIPTION_ERROR_RESET = 'subscription.ERROR_RESET';
export const SUBSCRIPTION_RETRIEVING = 'subscription.RETRIEVING';
export const SUBSCRIPTION_RETRIEVED = 'subscription.RETRIEVED';
export const SUBSCRIPTION_CREATING = 'subscription.CREATING';
export const SUBSCRIPTION_CREATED = 'subscription.CREATED';
export const SUBSCRIPTION_CANCELING = 'subscription.CANCELING';
export const SUBSCRIPTION_CANCELED = 'subscription.CANCELED';
export const SUBSCRIPTION_TOGGLE_MOBILE_SUPPORTED = 'subscription.TOGGLE_MOBILE_SUPPORTED';
export const SUBSCRIPTION_PROCESS_MOBILE_PAYMENT = 'subscription.PROCESS_MOBILE_PAYMENT';
export const SUBSCRIPTION_ERROR = 'subscription.ERROR';



// WEBPACK FOOTER //
// ./src/stores/subscriptions/action_types.js